<div class="relative inline-block">

  <img [src]="data.image"
       [alt]="data.alt"
       class="block w-auto max-w-full max-h-[85vh] rounded-lg" />

  <button type="button"
          (click)="cerrar()"
          aria-label="Cerrar publicidad"
          class="absolute top-2 right-2 flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-md text-pet-color-text-1 hover:bg-pet-gray-2">
    <mat-icon>close</mat-icon>
  </button>

</div>
